export const MONTHS_FR = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];

export const fmt3 = (v) => (v != null ? parseFloat(Number(v).toFixed(3)) : 0);

export const byIdMonth = (data, field) => {
  const arr = Array(12).fill(0);
  (data || []).forEach((item) => {
    const m = item?.id?.month;
    if (m >= 1 && m <= 12) arr[m - 1] = fmt3(item[field]);
  });
  return arr;
};

export const byMonth = (data, field) => {
  const arr = Array(12).fill(0);
  (data || []).forEach((item) => {
    const m = item?.month;
    if (m >= 1 && m <= 12) arr[m - 1] = fmt3(item[field]);
  });
  return arr;
};

// Linear-regression forecast for the months without data (value 0).
// Returns 12 values: forecast for empty months, 0 for months with real data.
export const computePrevision = (arr) => {
  const points = [];
  arr.forEach((v, i) => {
    if (v > 0) points.push({ x: i + 1, y: v });
  });

  if (points.length < 2) {
    if (points.length === 1) {
      const avg = points[0].y;
      return arr.map((v) => (v > 0 ? 0 : fmt3(avg)));
    }
    return Array(12).fill(0);
  }

  const n = points.length;
  const sumX = points.reduce((s, p) => s + p.x, 0);
  const sumY = points.reduce((s, p) => s + p.y, 0);
  const sumXY = points.reduce((s, p) => s + p.x * p.y, 0);
  const sumX2 = points.reduce((s, p) => s + p.x * p.x, 0);
  const denom = n * sumX2 - sumX * sumX;

  if (denom === 0) {
    const avg = sumY / n;
    return arr.map((v) => (v > 0 ? 0 : fmt3(avg)));
  }

  const slope = (n * sumXY - sumX * sumY) / denom;
  const intercept = (sumY - slope * sumX) / n;
  const predict = (x) => fmt3(Math.max(0, slope * x + intercept));

  return arr.map((v, i) => (v > 0 ? 0 : predict(i + 1)));
};

export const mergedSum = (actual, prev) =>
  actual.map((v, i) => (v > 0 ? v : prev[i])).reduce((a, b) => a + b, 0);

export const buildChart = (curr, currPrev, yearN, yearP, colorSolid, colorPrev, colorOld) => {
  const prevision = computePrevision(curr);
  const merged = curr.map((v, i) => (v > 0 ? v : prevision[i]));
  const bgColors = curr.map((v) => (v > 0 ? colorSolid : colorPrev));
  const bdColors = curr.map((v) => (v > 0 ? colorSolid : colorSolid.replace(/[\d.]+\)$/, "1)")));

  return {
    labels: MONTHS_FR,
    datasets: [
      {
        label: `${yearN} (prévision = barres claires)`,
        data: merged,
        backgroundColor: bgColors,
        borderColor: bdColors,
        borderWidth: 1,
      },
      {
        label: `${yearP}`,
        data: currPrev,
        backgroundColor: colorOld,
        borderWidth: 0,
      },
    ],
  };
};

export const chartOpts = () => ({
  responsive: true,
  plugins: {
    legend: { position: "top" },
    tooltip: {
      callbacks: {
        label: (ctx) => {
          const label = ctx.dataset.label?.split(" (")[0] || "";
          if (ctx.datasetIndex === 0) {
            const bg = Array.isArray(ctx.dataset.backgroundColor)
              ? ctx.dataset.backgroundColor[ctx.dataIndex]
              : ctx.dataset.backgroundColor;
            const isPrevision = bg && bg.includes("0.25");
            return `${isPrevision ? "Prévision" : "Réel"} ${label} : ${fmt3(ctx.raw)}`;
          }
          return `${label} : ${fmt3(ctx.raw)}`;
        },
      },
    },
  },
  scales: { y: { beginAtZero: true } },
});

export const evolution = (curr, prev) => {
  if (!prev || prev === 0) return null;
  return ((curr - prev) / Math.abs(prev)) * 100;
};
